import { render, staticRenderFns } from "./TemplateFDA.vue?vue&type=template&id=052359fc&"
import script from "./TemplateFDA.vue?vue&type=script&lang=ts&"
export * from "./TemplateFDA.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateFDA.vue?vue&type=style&index=0&id=052359fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports